import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'menu-button',
  templateUrl: './menu-button.component.html',
  styleUrls: ['./menu-button.component.css'],
  standalone: false
})
export class MenuButtonComponent {
  @Input() items: {label: string, action: string}[] = [];
  @Input() buttonIcon: string = '⋮';
  @Output() itemSelected = new EventEmitter<string>();
  
  isMenuOpen = false;

  toggleMenu(event?: Event) {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu() {
    this.isMenuOpen = false;
  }

  onItemClick(action: string) {
    this.itemSelected.emit(action);
    this.closeMenu();
  }
}